var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"small-form"},[_vm._l(([0, 1]),function(index){return _c('SearchAddress',{key:index,attrs:{"store":_vm.store,"index":index,"Api":_vm.Api,"isOpen":true}})}),_vm._v(" "),_c('button',{staticClass:"single-button",on:{"click":function($event){return _vm.store.stateFull(true);}}},[_vm._v("Оформить заказ")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-039c8484","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/SmallForm/Index.vue
// module id = 47
// module chunks = 0